import Card from "./Card";
import GeneBasicInfoCard from "./genePageCards/GeneBasicInfoCard";
import GeneGHRCard from "./genePageCards/GeneGHRCard";
import RegionBrowserCard from "./sharedCards/RegionBrowserCard";
import StructuralVariantsCard from "./sharedCards/StructuralVariantsCard";
import GeneTranscriptsCard from "./genePageCards/GeneTranscriptsCard/GeneTranscriptsCard";
import PublicationsCard from "./sharedCards/PublicationsCard";
import GeneKnownPathogenicityCard from "./genePageCards/GeneKnownPathogenicityCard";
import GeneGTExCard from "./genePageCards/GeneGTExCard";
import GeneDbNSFPCard from "./genePageCards/GeneDbNSFPCard";
import GeneGnomadCard from "./genePageCards/GeneGnomadCard";
import GeneClingenCard from "./genePageCards/GeneClingenCard";
import GeneEBIGene2PhenotypeCard from "./genePageCards/GeneEBIGene2PhenotypeCard";
import GeneNIHClinGenDiseaseValidityCard from "./genePageCards/GeneNIHClinGenDiseaseValidityCard/GeneNIHClinGenDiseaseValidityCard";
import GeneGenCCCard from "./genePageCards/GeneGenCCCard";
import GeneUnilDominoCard from "./genePageCards/GeneUnilDominoCard";
import GenePanelAppCard from "./genePageCards/GenePanelAppCard";
import GeneCGDCard from "./genePageCards/GeneCGDCard";
import GeneHpoTreeCard from "./genePageCards/GeneHpoTreeCard";
import GeneProteinAtlasCard from "./genePageCards/GeneProteinAtlasCard";
import CommunityContributionsGeneCard from "./genePageCards/community-contributions/CommunityContributionsGeneCard";
import GeneFusionGdbCard from "./genePageCards/GeneFusionGdbCard";
import PMKBGeneCard from "./genePageCards/GenePMKBCard";
import CivicGeneCard from "./genePageCards/GeneCIVICCard";
import JAXCKBGeneCard from "./genePageCards/GeneJAXCKBCard";
import PharmGKBGeneCard from "./genePageCards/pharmGKBGeneCard/PharmGKBGeneCard";
import GeneAACTCard from "./genePageCards/GeneAACTCard/GeneAACTCard";
import GeneFDACard from "./genePageCards/GeneFDACard/GeneFDACard";
import GeneDGICard from "./genePageCards/GeneDGICard/GeneDGICard";
import GeneCPICCard from "./genePageCards/GeneCPICCard/GeneCPICCard";
import GeneCGCCard from "./genePageCards/GeneCGCCard";
import GeneResults from "../../pages/gene/containers/GeneResults";
import Publications from "../Publications/components/MainPublications";
import CommunityContributions from "../../pages/variant/components/CommunityContributions";
import RegionBrowser from "../../browsers/RegionBrowser";
import StructuralBrowser from "../../browsers/StructuralBrowser";
import ProteinViewerCard from "./sharedCards/ProteinViewerCard";
import ProteinViewerContainer from "../3d-protein-viewer/ProteinViewerContainer";
import { setProteinViewerState } from "../../state/actions/genericActions";
import GeneOMIMCard from "./genePageCards/GeneOMIMCard";
import store from "../../state/store";
import GeneLOVDCard from "./genePageCards/GeneLOVDCard/GeneLOVDCard";
import PortalPublications from "../Publications/components/PortalPublications/EmulateClinical";

const general = "general";
const drugs = "drugs";
const germline = "germline";
const cancer = "cancer";
const misc = "misc";
const defaultCat = misc;

function getCategoryMap(cardItems) {
  return cardItems.reduce(
    (a, i) =>
      a.set(i.category || defaultCat, [
        ...(a.get(i.category || defaultCat) || []),
        i,
      ]),
    new Map()
  );
}

const cardsArr = [
  {
    id: "geneBasicInfo",
    title: "Gene basic Info",
    isPremium: false,
    CardComp: GeneBasicInfoCard,
    Comp: GeneResults,
    category: general,
  },
  {
    id: "geneGHR",
    title: "Gene function",
    isPremium: false,
    CardComp: GeneGHRCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "regionBrowser",
    title: "Region Browser",
    isPremium: false,
    CardComp: RegionBrowserCard,
    Comp: RegionBrowser,
    category: general,
    isNew: false,
  },
  {
    id: "structuralVariants",
    title: "Structural Variants",
    isPremium: false,
    CardComp: StructuralVariantsCard,
    Comp: StructuralBrowser,
    category: general,
    isNew: false,
  },
  {
    id: "geneTranscripts",
    title: "Transcripts",
    isPremium: false,
    CardComp: GeneTranscriptsCard,
    Comp: GeneResults,
    category: general,
  },
  {
    id: "publications",
    title: "Publications",
    isPremium: false,
    CardComp: PublicationsCard,
    Comp: Publications,
    category: general,
  },
  {
    id: "geneKnownPathogenicity",
    title: "Known gene variants",
    isPremium: false,
    CardComp: GeneKnownPathogenicityCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneGTEx",
    title: "Gene Expression",
    isPremium: false,
    CardComp: GeneGTExCard,
    Comp: GeneResults,
    category: general,
  },
  {
    id: "dbnsfpGenes",
    title: "dbNSFP",
    isPremium: false,
    CardComp: GeneDbNSFPCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneGnomad",
    title: "GnomAD Genes",
    isPremium: false,
    CardComp: GeneGnomadCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneEbiGene2Phenotype",
    title: "EBI Gene2Phenotype",
    isPremium: false,
    CardComp: GeneEBIGene2PhenotypeCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneGenCc",
    title: "GenCC",
    isPremium: false,
    CardComp: GeneGenCCCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneNihClinGenDiseaseValidity",
    title: "ClinGen Disease Validity",
    isPremium: false,
    CardComp: GeneNIHClinGenDiseaseValidityCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "geneClingen",
    title: "ClinGen",
    isPremium: false,
    CardComp: GeneClingenCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "unilDomino",
    title: "DOMINO",
    isPremium: false,
    CardComp: GeneUnilDominoCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "panelApp",
    title: "PanelApp gene lists",
    isPremium: false,
    CardComp: GenePanelAppCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "cgd",
    title: "Clinical Genomic Database",
    isPremium: false,
    CardComp: GeneCGDCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "hpoTree",
    title: "Human Phenotype Ontology",
    isPremium: false,
    CardComp: GeneHpoTreeCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "proteinAtlas",
    title: "Human Protein Atlas",
    isPremium: false,
    CardComp: GeneProteinAtlasCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "fusionGdb",
    title: "Fusion GDB",
    isPremium: false,
    CardComp: GeneFusionGdbCard,
    Comp: GeneResults,
    category: germline,
  },
  {
    id: "communityContributions",
    title: "Community Contributions",
    isPremium: false,
    CardComp: CommunityContributionsGeneCard,
    Comp: CommunityContributions,
  },
  {
    id: "geneCivic",
    title: "CIViC",
    isPremium: false,
    CardComp: CivicGeneCard,
    Comp: GeneResults,
    category: cancer,
  },
  {
    id: "genePmkb",
    title: "PMKB",
    isPremium: false,
    CardComp: PMKBGeneCard,
    Comp: GeneResults,
    category: cancer,
  },
  {
    id: "cancerGeneCensus",
    title: "Cancer Gene Census",
    isPremium: false,
    CardComp: GeneCGCCard,
    Comp: GeneResults,
    category: cancer,
  },
  {
    id: "geneJax",
    title: "JAX CKB",
    isPremium: false,
    CardComp: JAXCKBGeneCard,
    Comp: GeneResults,
    category: cancer,
  },
  {
    id: "pharmGKBGene",
    title: "Pharm GKB",
    isPremium: true,
    CardComp: PharmGKBGeneCard,
    Comp: GeneResults,
    category: drugs,
  },
  {
    id: "aact",
    title: "AACT Clinical Trials",
    isPremium: true,
    CardComp: GeneAACTCard,
    Comp: GeneResults,
    category: drugs,
  },
  {
    id: "dgi",
    title: "DGI",
    isPremium: true,
    CardComp: GeneDGICard,
    Comp: GeneResults,
    category: drugs,
  },
  {
    id: "fda",
    title: "FDA",
    isPremium: true,
    CardComp: GeneFDACard,
    Comp: GeneResults,
    category: drugs,
  },
  {
    id: "cpic",
    title: "CPIC",
    isPremium: true,
    CardComp: GeneCPICCard,
    Comp: GeneResults,
    category: drugs,
  },
  {
    id: "proteinViewerGene",
    title: "Protein Viewer",
    isPremium: false,
    disableScroll: true,
    CardComp: ProteinViewerCard,
    Comp: ProteinViewerContainer,
    category: general,
    onSelectHooks: [() => store.dispatch(setProteinViewerState(true))],
  },
  {
    id: "omimGene",
    title: "OMIM ®",
    category: cancer,
    CardComp: GeneOMIMCard,
    Comp: GeneResults,
    isPremium: true,
    isNew: false,
  },
  {
    id: "lovdGene",
    title: "LOVD",
    category: cancer,
    CardComp: GeneLOVDCard,
    Comp: GeneResults,
    isNew: true,
    isPremium: true,
  },
  {
    id: "portalPublications",
    title: "Publications Clinical",
    category: null,
    CardComp: PublicationsCard,
    Comp: PortalPublications,
    disableScroll: true,
    preventClinicalRemount: true,
  },
];

export const cards = cardsArr
  .map((x) => new Card(x))
  .reduce((a, i) => ({ ...a, [i.id]: i }), {});

export function groupCards(cardItems, columns) {
  const groups = getCategoryMap(cardItems);
  const generalCards = groups.get(general) || [];
  const miscCards = groups.get(misc) || [];
  const drugCards = groups.get(drugs) || [];
  const germlineCards = groups.get(germline) || [];
  const cancerCards = groups.get(cancer) || [];
  const strongGroups = [germlineCards, cancerCards, drugCards];
  const maxStrong = columns - 2;
  const downgraded = strongGroups.slice(maxStrong);
  const weak = [generalCards, ...downgraded, miscCards];

  return {
    weakCards: weak.reduce((a, i) => [...a, ...i], []),
    strongColumns: strongGroups.slice(0, maxStrong),
  };
}

const addClinicalCards =
  process.env.NODE_ENV === "development" &&
  window.location.origin === "http://local.varsome.com:3000" &&
  localStorage.getItem("emulate-clinical");

export const genePageCards = [
  addClinicalCards ? cards.portalPublications : null,
  cards.geneBasicInfo,
  cards.geneGHR,
  cards.regionBrowser,
  cards.structuralVariants,
  cards.geneTranscripts,
  cards.publications,
  cards.geneKnownPathogenicity,
  cards.geneGTEx,
  cards.geneJax,
  cards.geneCivic,
  cards.genePmkb,
  cards.dbnsfpGenes,
  cards.geneGnomad,
  cards.geneEbiGene2Phenotype,
  cards.geneGenCc,
  cards.geneNihClinGenDiseaseValidity,
  cards.geneClingen,
  cards.unilDomino,
  cards.panelApp,
  cards.cgd,
  cards.hpoTree,
  cards.proteinAtlas,
  cards.fusionGdb,
  cards.communityContributions,
  cards.cancerGeneCensus,
  cards.pharmGKBGene,
  cards.fda,
  cards.dgi,
  cards.cpic,
  cards.aact,
  cards.proteinViewerGene,
  cards.omimGene,
  cards.lovdGene,
].filter(Boolean);
